import React from "react";
import NavigateButton from "../../Components/UI/Buttons/NavigateButton";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWrench } from "@fortawesome/free-solid-svg-icons";

const UnderMaintenance = () => {
  const {t} = useTranslation()
  return (
    <div className="flex flex-col border-4 border-[#E0F5FD] overflow-autoh-full w-full items-center justify-center py-16 bg-gray-100 bg-opacity-30 h-full">
      <FontAwesomeIcon icon={faWrench} className="text-5xl pb-4" />

      <h1 className="text-4xl font-bold mb-4">
        {t("other.under_construction")||" This page is under construction" || "We'll be back soon!"}
      </h1>
      {/* <p className="text-xl mb-8">
        Sorry for the inconvenience but we're performing some maintenance at the
        moment.
      </p> */}
      {/* <p className="text-lg">
        If you need to, you can always
        <a
          href="mailto:support@example.com"
          className="text-blue-500 hover:underline"
        >
          contact us
        </a>
        , otherwise we'll be back online shortly!
      </p> 
      <p className="text-md mt-4">— The Team</p>*/}
      <div className="flex justify-center items-center gap-2">
        <NavigateButton />
        {/*  <NavigateButton  text='dashboard'/>    */}
      </div>
    </div>
  );
};

export default UnderMaintenance;
